import { IsPartnerModelType } from './types';
import { IsPartnerApi } from '@project/services';

export const IsPartnerModel = (data: IsPartnerApi): IsPartnerModelType => ({
  isPartner: data?.is_partner ?? false,
  isGuest: data?.is_guest ?? false,
});
